// extracted by mini-css-extract-plugin
module.exports = {"customToggle":"AccordionContainer_customToggle__tjIGM","show":"AccordionContainer_show__r4ks4"};